/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { Button } from "../../../components/ui/button"
import { useDisplayIPInterfaceData } from "./hooks";

import "../Config.css";
import { useStoreDispatch } from "../../../store/hooks";
import { setOpenCustomDailog } from "../../../store/helpers/helperReducers";
import { useSelector } from "react-redux";
import AddEditLanDevice from "../../../components/Configuration/IPInterface/AddEditLanDevice";
import { basicDialogSelector, confirmDialogSelector, customDialogSelector } from "../../../store/helpers/helperSelectors";
import { setIsAddNewLanDevice, setSelectedLanDevice } from "../../../store/api/deviceConfig/reducers";
import AddEditIPInterface from "../../../components/Configuration/IPInterface/AddEditIPInterface";
import ConfirmDialog from "../../../components/Shared/Dialogs/ConfirmDialog";
import CollapsibleTable from "../../../components/Shared/Table/CollapsibleTable";
import { constStr } from "../../../globals/constants";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { Plus } from "lucide-react";

const IPInterfaces: React.FC = () => {
  const dispatch = useStoreDispatch();
  const { permissions, data, isLoading, lanDeviceInterfaceColumn, selectedLanDevice, selectedIPInterface, deleteLANDeviceHandler } =
    useDisplayIPInterfaceData();
  const rowsData = data || [];
  //const rowsData = prepareIPInterfaceDataGrid(getDataFromServer);
  //const [NoOfSelectedRow, setNoOfSelectedRow] = React.useState(0);
  const [modelOpenMode, setModelOpenMode] = React.useState("Add");

  const openCustomDialog = useSelector(customDialogSelector);
  const basicDialogOpenFor = useSelector(basicDialogSelector);
  const openConfirmDialog = useSelector(confirmDialogSelector);
  const selectedDevice = useSelector(selectedDeviceSelector);
  const isOfflineDevice = selectedDevice?.configurationStatus?.toLowerCase() === "offline";
  // const handleOnMoreActionSelect = (params: any) => {
  //   console.log(params?.value);
  // };

  // const selectMoreActionProps = {
  //   id: "moreAction-select-small",
  //   labelId: "moreAction-select-small",
  //   inputLabel: "MORE ACTION",
  //   selectOptions: ["Action A", "Action B", "Action c"],
  // };
  const handleOnAddLanDevice = () => {
    setModelOpenMode("Add");
    dispatch(setIsAddNewLanDevice(true));
    dispatch(setOpenCustomDailog(true));
  };

  const onRowClick = (selectedRow: any) => {
    !!selectedRow && dispatch(setSelectedLanDevice(selectedRow));
  };

  return (
    <>
      {openCustomDialog && <AddEditLanDevice modelOpenMode={modelOpenMode} selectedLanDevice={selectedLanDevice} />}
      {basicDialogOpenFor === DIALOGOPENFOR.IPINTERFACE && (
        <AddEditIPInterface modelOpenMode={modelOpenMode} selectedIPInterface={selectedIPInterface} />
      )}

      <ConfirmDialog actionName={constStr.yesDelete} handleClickAction={deleteLANDeviceHandler}>
        {openConfirmDialog === DIALOGOPENFOR.LANDEVICE && `Are you sure you want to delete ${selectedLanDevice.name}?`}
        {openConfirmDialog === DIALOGOPENFOR.IPINTERFACE &&
          `Are you sure you want to delete IPInterface.${selectedIPInterface.index} of ${selectedLanDevice.name}?`}
      </ConfirmDialog>
      <div className="w-full h-full flex flex-col min-h-0">
        <div
          style={{
            flex: 1,
            minHeight: 0,
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius)",
            padding: "18px",
            boxShadow: "var(--shadow-card)",
            backgroundColor: "var(--card)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Add LAN Device Button */}
          {permissions?.hasOpCodeGroup("manage_sn") && !isOfflineDevice && (
            <div className="flex justify-end pt-2 pb-4">
              <Button
                onClick={handleOnAddLanDevice}
                variant="outline"
                className="
                  h-10
                  px-4
                  text-sm
                  font-medium
                  border
                  border-input
                  bg-background
                  shadow-sm
                  flex
                  items-center
                  gap-2
                  hover:bg-muted
                  hover:text-accent-foreground
                  transition-colors
                "
              >
                <Plus className="h-4 w-4" />
                Add LAN Device
              </Button>

            </div>
          )}

          {/* Table */}
          <div className="ml-1 border border-border rounded-[var(--radius)] flex-1 min-h-0 flex flex-col overflow-hidden" style={{}}>
            {isLoading && <p>Loading...</p>}

            {!isLoading && (
              <CollapsibleTable
                rowsData={rowsData}
                columns={lanDeviceInterfaceColumn}
                childHeader={"IPInterfaces"}
                onRowClick={onRowClick}
                style={{ flex: 1, minHeight: 360, height: "100%" }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default IPInterfaces;
